import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./index.less";
import { Button, Dropdown, MenuProps, Popover, TabsProps, Tooltip } from "antd";
import {
    ChatRecordIcon,
    InviteFriendIcon,
    DisabledInviteFriendIcon,
} from "../../SvgIconCom/PrivateChatTopIcon";
import { useTranslate } from "@obsbot/remo-i18n";
import { ContentTabsTop } from "../ContentTabsTop";
import { AvatarCom, RelationshipType } from "../../AvatarCom";
import { ContactItem } from "../ContactList";
import { useParams } from "react-router-dom";
import {
    useChannelRoomStore,
    useChannelStore,
    useChatStore,
    useFriendStore,
    useGlobalStore,
} from "@obsbot/remo-stores";
import { SearchMsg } from "../ChatMsg/SearchMsg";
import {
    CustomType,
    ICustomPayload,
    ICustomPayloadDescription,
    IServiceTextChat,
} from "@obsbot/remo-services";
import { IMsgItem } from "../ChatMsg";
import { eventBus } from "@obsbot/remo-utils";
import Search from "antd/es/input/Search";
import { ChatSearchSVG } from "../../SvgIconCom";
import { CloseOutlined } from "@ant-design/icons";
import { MSG_TYPES } from "@obsbot/remo-service-provider-tencent-rtm/src/reflect-type";
import { throttle } from "lodash-es";
import { REMO_GAME_WEB_URL, setInviteURLTime } from "@obsbot/remo-server-api";
export interface ChatPrivateTopProps {
    title: string;
    chatUser?: ContactItem;
    cacheMap: Map<string, IMsgItem[]>;
}

export const keyTypeMap: Record<string, string | string[]> = {
    msg: "TIMTextElem",
    img: "TIMImageElem",
    video: "TIMVideoFileElem",
};

export const ChatPrivateTop: React.FC<ChatPrivateTopProps> = ({ chatUser, cacheMap }) => {
    const { rtm } = useChatStore();
    const t = useTranslate();
    const [searchData, setSearchData] = useState<IMsgItem[] | null>([]);
    const tabItems: TabsProps["items"] = [
        {
            key: "all",
            label: t("chat.all", { user: "" }),
        },
        {
            key: "msg",
            label: t("chat.msg"),
        },
        {
            key: "img",
            label: t("chat.img"),
        },
        {
            key: "video",
            label: t("chat.video"),
        },
    ];
    const [isOpenInvite, setIsOpenInvite] = useState(false);
    const { channels, updateChannelInviteFlag } = useChannelStore();
    const [isOpenMsg, setIsOpenMsg] = useState(false);
    const { conversationOnline, friendList } = useFriendStore();
    const { blockedUsers } = useChannelRoomStore();
    const { userInfo } = useGlobalStore();
    const [relation, setRelation] = useState<RelationshipType>();
    const [showSearchInput, setShowSearchInput] = useState<boolean>(false);
    const params = useParams();
    const [activeTab, setActiveTab] = useState("all");

    const handleInvite = useCallback(
        async ({ item }: { item: any }): Promise<void> => {
            const uuid = item.props.uuid;
            // 确保拿到最新的频道列表
            const inviteFlag = useChannelStore.getState().channels.get(uuid)?.inviteFlag;
            if (!inviteFlag) {
                return;
            }
            if (params.id && rtm && userInfo?.user_id) {
                if (blockedUsers.includes(params.id)) {
                    eventBus.emit("show-message", {
                        message: t("error_code.RM.20005"),
                        type: "warning",
                    });
                    return;
                }
                const res = await rtm.checkFriend([userInfo.user_id, params.id]);
                if (res) {
                    const { data: invite_flag } = await setInviteURLTime(inviteFlag, uuid);
                    updateChannelInviteFlag(uuid, invite_flag);
                    const inviteUrl = `${REMO_GAME_WEB_URL}#/channel/invite/${invite_flag}`;
                    const payload: ICustomPayload = {
                        data: inviteUrl,
                        description: ICustomPayloadDescription.Link,
                    };
                    await rtm.sendPeerMessage(CustomType.Custom, params.id, payload);
                    eventBus.emit("send-new-msg", {
                        userID: params.id,
                    });
                } else {
                    eventBus.emit("show-message", {
                        message: t("chat.invite-channel-no-right"),
                        type: "warning",
                    });
                }
            }
        },
        [params.id, rtm],
    );

    // @ts-ignore
    const channelMenu: MenuProps = useMemo(() => {
        const tempMenuList = [];
        for (const [, value] of channels) {
            if (value.ownerUuid === userInfo?.user_id) {
                tempMenuList.push({
                    label: value.channelName,
                    key: value.inviteFlag,
                    uuid: value.channelUuid,
                    flag: value.inviteFlag,
                });
            }
        }
        return { items: [...tempMenuList], onClick: handleInvite };
    }, [channels, handleInvite]);

    const getRelationship = (groupList: any[]): RelationshipType | undefined => {
        const relationshipTypes = ["lovers", "buddy", "bosom_friend"];
        let result: RelationshipType | undefined = undefined;
        groupList &&
            groupList.forEach((item: RelationshipType) => {
                if (relationshipTypes.includes(item)) {
                    result = item;
                }
            });
        return result;
    };

    const conversationID = useMemo(() => {
        const friend = friendList.find(item => item.userID === params.id);
        const relation = getRelationship(friend?.groupList || []);
        setRelation(relation);
        return params.id ? "C2C" + params.id : "";
    }, [params.id, friendList]);

    useEffect(() => {
        setSearchData([]);
        setShowSearchInput(false);
    }, [conversationID]);

    const handleChangeTab = useCallback(
        async (key: string): Promise<void> => {
            setActiveTab(key);
            if (!rtm) {
                return;
            }
            const allMessage = await getAllMessages(rtm, conversationID);
            const filterMessage =
                key === "all"
                    ? allMessage
                    : allMessage.filter(item => {
                          // 自定义消息也展示
                          if (keyTypeMap[key] === "TIMTextElem" && item.type === "TIMCustomElem") {
                              return true;
                          }
                          return item.type === (keyTypeMap[key] as any);
                      });
            setSearchData(filterMessage.length ? filterMessage : null);
        },
        [rtm, conversationID],
    );

    const handleSearch = useCallback(
        async (searchKey: string): Promise<void> => {
            if (!rtm) {
                return;
            }
            console.log("查询值", searchKey, !searchKey);
            if (!searchKey) {
                setSearchData([]);
                return;
            }
            const allMessage = await getAllMessages(rtm, conversationID);
            const filterMessage = allMessage
                .filter(message =>
                    activeTab === "all" ? true : message.type === keyTypeMap[activeTab],
                )
                .filter(message => {
                    if (message.type === MSG_TYPES.text) {
                        return message.payload.text?.includes(searchKey);
                    } else if (message.type === MSG_TYPES.image) {
                        const name = message.cloudCustomData;
                        return name?.includes(searchKey);
                    } else if (message.type === MSG_TYPES.video) {
                        const name = message.cloudCustomData;
                        return name?.includes(searchKey);
                    } else {
                        return false;
                    }
                });
            setSearchData(filterMessage.length ? filterMessage : null);
        },
        [rtm, conversationID, activeTab],
    );

    useEffect(() => {
        if (!rtm) {
            return;
        }
        const handleConversationUpdated = async (event: any): Promise<void> => {
            const newMessageConversationID = event[0].conversationID;
            if (cacheMap.has(newMessageConversationID)) {
                cacheMap.delete(newMessageConversationID);
            }
        };
        // 接收到消息
        rtm.events.on("conversation-list-updated", handleConversationUpdated);
        return () => {
            rtm.events.off("conversation-list-updated", handleConversationUpdated);
        };
    }, [rtm, cacheMap]);

    const getAllMessages = async (
        rtm: IServiceTextChat,
        conversationID: string,
    ): Promise<IMsgItem[]> => {
        if (cacheMap.has(conversationID)) {
            return cacheMap.get(conversationID)!;
        }
        let messages: IMsgItem[] = [];
        let seqId = "";
        let isFirstIn = true;
        while (seqId || isFirstIn) {
            isFirstIn = false;
            const res = await rtm.getMessageList(conversationID, seqId);
            messages = [...messages, ...res.messageList];
            seqId = res.nextReqMessageID;
        }
        cacheMap.set(conversationID, messages);
        return messages.sort((a, b) => b.time - a.time);
    };

    return (
        <div className="chat-private-top">
            <div className="top-title">
                <AvatarCom
                    {...chatUser?.userProfile}
                    relationship={relation}
                    showStatus={true}
                    status={
                        params.id &&
                        (conversationOnline[params.id] === "invisible"
                            ? "offline"
                            : conversationOnline[params.id])
                    }
                    userName={chatUser?.userProfile?.nick}
                />
            </div>
            {params.id !== "administrator" && (
                <div className="actions">
                    <Dropdown
                        menu={channelMenu}
                        open={isOpenInvite}
                        trigger={["click"]}
                        onOpenChange={(open: boolean) => setIsOpenInvite(open)}
                    >
                        <Tooltip
                            arrow={false}
                            className="tool-btn-tooltip"
                            placement="bottom"
                            title={t("chat.invite-to-channel")}
                        >
                            <Button
                                disabled={(channelMenu.items || []).length === 0}
                                icon={
                                    (channelMenu.items || []).length > 0 ? (
                                        <InviteFriendIcon isActive={isOpenInvite} />
                                    ) : (
                                        <DisabledInviteFriendIcon />
                                    )
                                }
                                type="text"
                            ></Button>
                        </Tooltip>
                    </Dropdown>
                    <Popover
                        content={
                            <div className={`top-search ${showSearchInput ? "has-search" : ""}`}>
                                {showSearchInput && (
                                    <div className="search-content">
                                        <Search
                                            allowClear={{
                                                clearIcon: (
                                                    <CloseOutlined
                                                        style={{
                                                            color: "var(--normal-white)",
                                                            opacity: 0.6,
                                                        }}
                                                    />
                                                ),
                                            }}
                                            className="search-input"
                                            enterButton={false}
                                            prefix={<ChatSearchSVG />}
                                            onChange={e => {
                                                const throttleSearch = throttle(handleSearch, 500);
                                                throttleSearch(e.target.value);
                                            }}
                                            onClear={() => handleSearch("")}
                                            onPressEnter={e => handleSearch(e.currentTarget.value)}
                                            onSearch={handleSearch}
                                        />
                                        <Button
                                            type="text"
                                            onClick={() => {
                                                handleSearch("");
                                                setShowSearchInput(false);
                                            }}
                                        >
                                            {t("cancel")}
                                        </Button>
                                    </div>
                                )}
                                <ContentTabsTop
                                    handleChangeTab={handleChangeTab}
                                    handleSearch={handleSearch}
                                    handleSearchInput={setShowSearchInput}
                                    showSearch={true}
                                    showSearchInput={showSearchInput}
                                    tabItems={tabItems}
                                />
                                {conversationID && (
                                    <SearchMsg
                                        activeTab={activeTab}
                                        conversationID={conversationID}
                                        isOpenMsg={isOpenMsg}
                                        searchData={searchData}
                                    />
                                )}
                            </div>
                        }
                        open={isOpenMsg}
                        rootClassName="chat-private-popover"
                        trigger={["click"]}
                        onOpenChange={(open: boolean) => setIsOpenMsg(open)}
                    >
                        <Tooltip
                            arrow={false}
                            className="tool-btn-tooltip"
                            placement="bottom"
                            title={t("chat.search")}
                        >
                            <Button
                                icon={<ChatRecordIcon isActive={isOpenMsg} />}
                                type="text"
                            ></Button>
                        </Tooltip>
                    </Popover>
                </div>
            )}
        </div>
    );
};
